import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import basicQaidaImg from '../../images/service/service/Basic Qaida.webp'
import tajweedImg from '../../images/service/service/Tajweed.webp'
import tajweedImprovementImg from '../../images/service/service/Tajweed Improvement.webp'
import hifzImg from '../../images/service/service/Hifz.webp'
import PageTitle from '../pagetitle'
import coursesBanner from '../../images/banners/courses.webp'

import './style.css'

const Course = (props) => {

    const courses = [
        {
          cIcon:basicQaidaImg,
          heading:"Basic Qaida",
          pra:"Learn the Arabic alphabet, letter sounds and beginner reading skills – ideal for young children starting their Quran journey.",
          link: "/basic-qaida"
        },
        {
            cIcon:hifzImg,
            heading:"Hifz (Memorisation)",
            pra:"Structured memorisation programme for students aiming to memorise Surahs or the entire Quran, with patient support and review.",
            link: "/hifz"
          },
        {
          cIcon:tajweedImg,
          heading:"Tajweed",
          pra:"Master the rules of Quranic recitation (Tajweed) for clear, melodious reading of the Qur'an.",
          link: "/tajweed"
        },
        {
          cIcon:tajweedImprovementImg,
          heading:"Tajweed Improvement",
          pra:"Advance your recitation by refining pronunciation and fluency under expert guidance.",
          link: "/tajweed-improvement"
        }
    ]
    
    // Add intersection observer for scroll animations
    useEffect(() => {
        // Setup intersection observer for scroll-triggered animations
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                }
            });
        }, { threshold: 0.1 });
        
        // Observe course items
        document.querySelectorAll('.courses-item').forEach(item => {
            observer.observe(item);
        });
        
        return () => {
            // Cleanup observer on component unmount
            document.querySelectorAll('.courses-item').forEach(item => {
                observer.unobserve(item);
            });
        };
    }, []);
    
    const ClickHandler = () =>{
        window.scrollTo(10, 0);
    }
    
    return (
        <>
            {!props.isHomePage && (
                <PageTitle pageTitle={'Courses'} pagesub={'Courses'} backgroundImage={coursesBanner} hideText={true} />
            )}
            <div className="courses-area">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="wpo-section-title text-center">
                                <span>Featured Courses</span>
                                <h2>Our Popular Courses</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {courses.map((course, i) => (
                            <div className="col-lg-6 col-md-6 col-sm-12" key={i}>
                                <Link to={course.link} onClick={ClickHandler} className="course-link">
                                    <div className="courses-item">
                                        <div className="light-sweep"></div>
                                        <div className="course-icon">
                                            <span><img src={course.cIcon} alt="" /></span>
                                        </div>
                                        <div className="course-text">
                                            <h2>{course.heading}</h2>
                                            <p>{course.pra}</p>
                                        </div>
                                        <div className="course-btn">
                                            <span>Learn More <i className="fa fa-arrow-right"></i></span>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Course;